import React from 'react'
import cn from 'classnames'
import { FilmGrainOptions, useFilmGrain } from './useFilmGrain'

export type FilmGrainImageProps = {
  image: {
    url: string
    alt: string
  }
  className?: string
  onRenderImage?: () => JSX.Element
}

const FilmGrainImage = ({
  image,
  className = '',
  canvasId,
  intensity = 25,
  onRenderImage
}: FilmGrainImageProps & FilmGrainOptions) => {
  const options: FilmGrainOptions = {
    canvasId,
    intensity
  }
  useFilmGrain(options)

  return (
    <div className={cn('film-grain-image overflow-hidden', className)}>
      <canvas id={`film-grain-canvas-${canvasId}`} />
      {onRenderImage ? onRenderImage() : <img src={image.url} alt={image.alt} className='h-100 w-100' />}
    </div>
  )
}

export default FilmGrainImage
